export default __webpack_public_path__ + "static/media/seguro_vida.082356cc.png";